import { render, staticRenderFns } from "./FulfillmentStatusBadge.vue?vue&type=template&id=196b447c"
import script from "./FulfillmentStatusBadge.vue?vue&type=script&lang=js"
export * from "./FulfillmentStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports